import CONSTANT from 'modules/constant'
import type { BookingServiceProps, ChargerFilterProps, PaginationProps } from 'modules/types'
import { API, download, 
    // downloadInovicesss, 
    headers } from './api'

const BookingServiceAPI = API.injectEndpoints({
    endpoints: (builder) => ({
        getServiceBookingList: builder.mutation<
            PaginationProps<BookingServiceProps>,
            FormData
        >({
            query: (body) => ({
                url: CONSTANT.URL_BOOKING_SERVICE_LIST,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                formData: true
            })
        }),
        downloaServicedBoking: builder.mutation<PaginationProps<BookingServiceProps>, FormData>({
            query: (body) => ({
                url: CONSTANT.URL_BOOKING_SERVICE_DOWNLOAD,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                formData: true,
                responseHandler: download
            })
        }),
        getDetailServiceBooking: builder.query<BookingServiceProps, number>({
            query: (id) => ({
                url: CONSTANT.URL_BOOKING_SERVICE_DETAIL + id,
                method: 'GET',
                headers: headers()
            })
        }),
        getAppointmentConfirmationDropdown: builder.mutation<ChargerFilterProps[], void>({
            query: () => ({
                url: CONSTANT.URL_BOOKING_SERVICE_APPOINTMENT_CONFIRMATION_DDL,
                method: 'GET',
                headers: headers()
            })
        }),
        getRepairStatusDropdown: builder.mutation<ChargerFilterProps[], void>({
            query: () => ({
                url: CONSTANT.URL_BOOKING_SERVICE_REPAIR_STATUS_DDL,
                method: 'GET',
                headers: headers()
            })
        }),
        getTransactionStatusDropdown: builder.mutation<ChargerFilterProps[], void>({
            query: () => ({
                url: CONSTANT.URL_BOOKING_SERVICE_TRANSACTION_STATUS_DDL,
                method: 'GET',
                headers: headers()
            })
        }),
        getRepairSelectionDropdown: builder.mutation<ChargerFilterProps[], void>({
            query: () => ({
                url: CONSTANT.URL_BOOKING_SERVICE_REPAIR_SELECTION_DDL,
                method: 'GET',
                headers: headers()
            })
        }),
        getServicepackageDropdown: builder.mutation<ChargerFilterProps[], void>({
            query: () => ({
                url: CONSTANT.URL_BOOKING_SERVICE_SERVICE_PACKAGE_DDL,
                method: 'GET',
                headers: headers()
            })
        }),
        getInvoice: builder.mutation<string, number>({
            query: (id) => ({
                url: CONSTANT.URL_BOOKING_SERVICE_SERVICE_VIEW_INVOICE + id,
                method: 'GET',
                headers: headers(),
                responseHandler: (h) => h.text()
            })
        }),
        
        

    })
})

export const {
    useGetServiceBookingListMutation,
    useDownloaServicedBokingMutation,
    useGetDetailServiceBookingQuery,
    useGetAppointmentConfirmationDropdownMutation,
    useGetRepairStatusDropdownMutation,
    useGetTransactionStatusDropdownMutation,
    useGetRepairSelectionDropdownMutation,
    useGetServicepackageDropdownMutation,
    useGetInvoiceMutation
} =
    BookingServiceAPI
